import { ReactNode } from 'react'
import { BetriebsstelleSearchProvider as UIBetriebsstelleSearchProvider } from '@repo/ui'

interface BetriebsstelleSearchProviderProps {
  children: ReactNode
}

/**
 * TF-App specific BetriebsstelleSearchProvider without search API (no autocomplete)
 *
 * This provider does NOT provide a search API, which means BetriebsstelleField
 * components will fallback to simple input fields without autocomplete functionality.
 * This is intentional as tf-app does not have access to the Betriebsstelle search API.
 */
export default function BetriebsstelleSearchProvider({
  children
}: Readonly<BetriebsstelleSearchProviderProps>) {
  return (
    <UIBetriebsstelleSearchProvider>{children}</UIBetriebsstelleSearchProvider>
  )
}
